const Common = {
  '请稍等': 'Please wait',
  '操作成功': 'Operation successful',
  '正常': 'Normal',
  '系统加载中': 'System loading',
  '新增': 'Add',
  '编辑': 'Edit',
  '已选中#条记录': 'Selected # record(s)',
  '未选中任何数据': 'No data selected',
  '清空': 'Clear',
  '删除': 'Delete',
  '批量删除': 'Batch Delete',
  '详情': 'Detail',
  '活跃': 'Active',
  '冻结': 'Freeze',
  '启用': 'Enable',
  '搜索': 'Search',
  '重置': 'Reset',
  '操作': 'Action',
  '取消': 'Cancel',
  '确定': 'Confirm',
  '状态': 'Status',
  '创建时间': 'Creation Time',
  '全选': 'Select All',
  '确定冻结': 'Confirm Freeze',
  '确定启用': 'Confirm Enable',
  '确定删除': 'Confirm Delete',
  '确定取消': 'Confirm Cancel',
  '确定完成': 'Confirm Completion',
  '确定下单': 'Confirm Order Placement',
  '确定作废': 'Confirm Void',
  '确定重置': 'Confirm Reset',
  '冻结成功': 'Freeze successfully',
  '启用成功': 'Enable successfully',
  '删除成功': 'Delete successfully',
  '重置成功': 'Reset successfully',
  '重置密码': 'Reset Password',
  '全部': 'All',
  '备注': 'Remark',
  '请输入备注': 'Please enter remark',
  '暂无数据': 'No Data',
  '装箱码': 'Packing Code',
  '请输入装箱码': 'Please enter packing code',
  '激活码': 'Activation Code',
  '请输入激活码': 'Please enter activation code',
  '产品码': 'Product Code',
  '请输入产品码': 'Please enter product code',
  '第三方激活码': 'Third-party Activation Code',
  '待完成': 'To be completed',
  '已收单': 'Order Received',
  '已完成': 'Completed',
  '已作废': 'Voided',
  '待下单': 'Pending Order Placement',
  '产品名称': 'Product Name',
  '产品图片': 'Product Image',
  '基本信息': 'Basic Information',
  '序号': 'Serial Number',
  '编码': 'Code',
  '请输入编码': 'Please enter code',
  '暂无': 'None',
  '待生产': 'Pending Production',
  '已装盒': 'Boxed',
  '已装箱': 'Cased',
  '生产入库': 'Production Inbound',
  '采购入库': 'Purchase Inbound',
  '销售出库': 'Sales Outbound',
  '出库激活': 'Outbound Activation',
  '电商激活': 'E-commerce Activation',
  '完成售后': 'After-sales Completed',
  '售后激活': 'After-sales Activation',
  '补货出库': 'Replenishment Outbound',
  '补货入库': 'Replenishment Inbound',
  '订单号': 'Order Number',
  '箱规': 'Box Specification',
  '请输入箱规': 'Please enter box specification',
  '箱规必须大于0': 'Case pack must be greater than 0',
  '请选择产品': 'Please select product',
  '上一步': 'Previous',
  '下一步': 'Next',
  '名称': 'Name',
  '图片': 'Image',
  '单价': 'Price',
  '通知': 'Notification',
  '开始日期': 'Start Date',
  '结束日期': 'End Date',
  '请输入': 'Please Enter',
  '打印': 'Print',
  '初始化打印程序失败，请联系技术人员处理': 'Failed to initialize the print program, please contact technical support.',
  '请选择打印机': 'Please select printer',
  '当前打印数据': 'Current print data',
  '打印进度': 'Print progress',
  '停止打印': 'Stop printing',
}

const Region = {
  '马来西亚': 'Malaysia',
  '玻璃市': 'Perlis',
  '吉打': 'Kedah',
  '槟城': 'Penang',
  '霹雳': 'Perak',
  '雪兰莪': 'Selangor',
  '森美兰': 'Negeri Sembilan',
  '马六甲': 'Malacca',
  '柔佛': 'Johor',
  '彭亨': 'Pahang',
  '登嘉楼': 'Terengganu',
  '吉兰丹': 'Kelantan',
  '砂拉越': 'Sarawak',
  '沙巴': 'Sabah',
  '吉隆坡': 'Kuala Lumpur',
  '纳闽': 'Labuan',
  '布城': 'Putrajaya',
  '印度尼西亚': 'Indonesia',
  '菲律宾': 'Philippines',
  '新加坡': 'Singapore',
  '泰国': 'Thailand',
  '越南': 'Vietnam',
  '缅甸': 'Myanmar',
  '东帝汶': 'East Timor',
  '文莱': 'Brunei',
  '柬埔寨': 'Cambodia',
  '老挝': 'Laos',
  '阿根廷': 'Argentina',
  '巴拉圭': 'Paraguay',
  '巴西': 'Brazil',
  '秘鲁': 'Peru',
  '玻利维亚': 'Bolivia',
  '厄瓜多尔': 'Ecuador',
  '法属圭亚那': 'French Guiana',
  '哥伦比亚': 'Colombia',
  '圭亚那': 'Guyana',
  '苏里南': 'Suriname',
  '委内瑞拉': 'Venezuela',
  '乌拉圭': 'Uruguay',
  '智利': 'Chile',
  '福克兰群岛': 'Falkland Islands',
}

const Layout = {
  '语言': 'Language',
  '简体中文': 'Simplified Chinese',
  '繁体中文': 'Traditional Chinese',
  '英文': 'English',
  '修改密码': 'Modify Password',
  '退出登录': 'Logout',
  '溯源管理系统': 'Traceability System',
}

const Menu = {
  '租户管理': 'Tenant',
  '租户列表': 'List',
  '新增租户': 'Add',
  '编辑租户': 'Edit',
  '删除租户': 'Delete',
  '系统管理': 'System',
  '角色管理': 'Role',
  '角色列表': 'List',
  '新增角色': 'Add',
  '编辑角色': 'Edit',
  '删除角色': 'Delete',
  '员工管理': 'Staff',
  '员工列表': 'List',
  '新增员工': 'Add',
  '编辑员工': 'Edit',
  '删除员工': 'Delete',
  '销售管理': 'Sales',
  '销售单': 'Sales Order',
  '销售单列表': 'List',
  '新增销售单': 'Add',
  '编辑销售单': 'Edit',
  '销售出库': 'Sales Outbound',
  '销售出库列表': 'List',
  '新增销售出库': 'Add',
  '采购管理': 'Purchase',
  '采购单': 'Purchase Order',
  '采购单列表': 'List',
  '新增采购单': 'Add',
  '编辑采购单': 'Edit',
  '采购入库': 'Purchase Inbound',
  '采购入库列表': 'List',
  '新增采购入库': 'Add',
  '产品管理': 'Product',
  '产品库': 'Product Warehouse',
  '产品列表': 'List',
  '新增产品': 'Add',
  '编辑产品': 'Edit',
  '删除产品': 'Delete',
  '在售产品': 'Product on Sale',
  '在售产品列表': 'List',
  '新增在售产品': 'Add',
  '删除在售产品': 'Delete',
  '供应商管理': 'Supplier',
  '供应商列表': 'List',
  '新增供应商': 'Add',
  '编辑供应商': 'Edit',
  '删除供应商': 'Delete',
  '代理管理': 'Agent',
  '代理列表': 'List',
  '只展示拥有的代理': 'Only display owned agents',
  '新增代理': 'Add',
  '编辑代理': 'Edit',
  '删除代理': 'Delete',
  '生产管理': 'Production',
  '生产单': 'Production Order',
  '生产单列表': 'List',
  '新增生产单': 'Add',
  '编辑生产单': 'Edit',
  '生产入库': 'Production Inbound',
  '生产入库列表': 'List',
  '新增生产入库': 'Add',
  '库存管理': 'Inventory',
  '库存明细': 'Inventory Detail',
  '库存明细列表': 'List',
  '库存变动': 'Inventory Change',
  '库存变动列表': 'List',
  '工厂测试': 'Factory Test',
  '扫码装盒': 'Scan to Box',
  '扫码装箱': 'Scan to Case',
  '扫码校验': 'Scan to Verify',
  '扫码激活': 'Scan to Activate',
  '电商激活': 'E-commerce Activation',
  '打印记录': 'Print Record',
  '打印记录列表': 'List',
  '新增打印记录': 'Add',
  '编辑打印记录': 'Edit',
  '溯源管理': 'Traceability',
  '售后管理': 'After-sales',
  '售后列表': 'List',
  '新增售后': 'Add',
  '退货管理': 'Return',
  '退货列表': 'List',
  '新增退货': 'Add',
  '编辑退货': 'Edit',
  'App用户管理': 'App User',
  'App用户列表': 'List',
  '编辑App用户': 'Edit',
  '删除App用户': 'Delete',
  '数据统计': 'Data Statistics',
  '激活记录': 'Activation Record',
  '编辑在售产品': 'Edit',
  '第三方激活码管理': 'Third-party Activation Code',
  '第三方激活码订单': 'Third-party Activation Code Order',
  '第三方激活记录': 'Third-party Activation Code Record',
  '第三方激活码订单列表': 'List',
  '新增第三方激活码订单': 'Add',
  '编辑第三方激活码订单': 'Edit',
  '通知管理': 'Notification',
  '代购管理': 'Purchasing Agent',
  '代购列表': 'List',
  '新增代购': 'Add',
  '只展示自己的代购': 'Only Display My Purchasing Agents',
  '活动管理': 'Campaign',
  '活动列表': 'List',
  '新增活动': 'Add',
  '编辑活动': 'Edit',
  '删除活动': 'Delete',
  '扫码验奖': 'Scan To Verify Prize',
}

const ModifyPasswordPage = {
  '修改密码': 'Modify Password',
  '旧密码': 'Old Password',
  '请输入旧密码': 'Please enter old password',
  '新密码': 'New Password',
  '请输入新密码': 'Please enter new password',
  '密码长度必须介于 6 和 20 之间': 'Password must be between 6 and 20 characters',
  '确认密码': 'Confirm Password',
  '请再次输入密码': 'Please enter password again',
  '两次输入的密码不一致': 'The passwords you entered do not match',
  '修改成功': 'Modify successfully',
}

const LoginPage = {
  '账号': 'Account',
  '请输入账号': 'Please enter account',
  '密码': 'Password',
  '请输入密码': 'Please enter password',
  '验证码': 'Captcha',
  '请输入验证码': 'Please enter captcha',
  '登录': 'Login',
}

const TenantPage = {
  '公司名称': 'Company Name',
  '公司联系方式': 'Company Contact Information',
  '公司邮箱': 'Company Email',
  '管理员名称': 'Administrator Name',
  '管理员联系方式': 'Administrator Contact Information',
  '管理员邮箱': 'Administrator Email',
  '菜单权限': 'Menu Permissions',
  '管理员账号': 'Administrator Account',
  '请输入公司名称': 'Please enter company name',
  '请输入公司联系方式': 'Please enter company contact information',
  '请输入公司邮箱': 'Please enter company email',
  '请输入管理员名称': 'Please enter administrator name',
  '请输入管理员联系方式': 'Please enter administrator contact information',
  '请输入管理员邮箱': 'Please enter administrator email',
  '邮箱格式错误': 'Email format error',
  '请选择菜单权限': 'Please select menu permissions',
  '新增租户': 'Add',
  '编辑租户': 'Edit',
  '查看租户': 'View',
}

const StaffPage = {
  '员工账号': 'Employee Account',
  '员工名称': 'Employee Name',
  '角色': 'Role',
  '请输入员工账号': 'Please enter employee account',
  '员工账号只能包含数字、英文大小写': 'Employee account can only contain numbers and letters (case-sensitive)',
  '员工账号长度必须介于 6 和 20 之间': 'Employee account must be between 6 and 20 characters',
  '账号只能包含数字、英文大小写': 'Account can only contain numbers and letters (case-sensitive)',
  '请输入员工名称': 'Please enter employee name',
  '请选择角色': 'Please select role',
}

const RolePage = {
  '角色名称': 'Role Name',
  '请输入角色名称': 'Please enter role name',
  '新增角色': 'Add Role',
  '编辑角色': 'Edit Role',
  '查看角色': 'View Role',
  '确定编辑？与该角色关联的账号的权限将会被覆盖': 'Confirm edit? Permissions of accounts associated with this role will be overwritten',
}

const PrintRecordPage = {
  '开始': 'Start',
  '确定开始': 'Confirm Start',
  '暂停': 'Pause',
  '确定暂停': 'Confirm Pause',
  '打印类型': 'Print Type',
  '总数量': 'Total Quantity',
  '打印数量': 'Print Quantity',
  '排队中': 'Queuing',
  '打印中': 'Printing',
  '已暂停': 'Paused',
  '已完成': 'Completed',
  '已取消': 'Cancelled',
  '打印机状态': 'Printer Status',
}

const ThirdPartyActivationCodeOrderPage = {
  '订单编号': 'Order Number',
  '作废后该订单的所有编码不可使用': 'All codes under this order will become invalid once voided',
  '数量': 'Quantity',
  '请输入数量': 'Please enter quantity',
  '数量必须大于0': 'Quantity must be greater than 0',
  '新增订单': 'Add',
  '未打印': 'Not Printed',
  '已打印': 'Printed',
  '异常打印': 'Abnormal Print',
  '打印': 'Print',
  '全部打印': 'Print All',
  '请先选择要打印的激活码': 'Please select the activation codes to print first',
  '打印任务已创建，请到打印记录中查看': 'Print task created. Please check the print records',
}

const ThirdPartyActivationCodeRecordPage = {
  '商品名称': 'Product Name',
  '保修天数': 'Warranty Days',
  '代理': 'Agent',
  '激活时间': 'Activation Time',
  '剩余保修天数': 'Remaining Warranty Days',
  '激活人': 'Activator',
}

const TraceCodePage = {
  '溯源': 'Traceability',
  '暂无溯源信息': 'No traceability information available',
  '产品信息': 'Product Information',
  '产品单价': 'Product Price',
  '包装信息': 'Packaging Information',
  '装箱信息': 'Packing Information',
  '装箱情况': 'Packing Status',
  '当前节点': 'Current Node',
  '产品节点': 'Product Node',
  '激活状态': 'Activation Status',
  '剩余时间（天）': 'Remaining Time (Days)',
  '销售门店': 'Sales Store',
  '激活账号': 'Activate Account',
  '绑定用户': 'Bound User',
  '已激活': 'Activated',
  '未激活': 'Not Activated',
}

const ReturnPage = {
  '我的退货': 'My Returns',
  '处理退货': 'Process Return',
  '确定收货': 'Confirm Receipt',
  '完成退货': 'Complete Return',
  '退货详情': 'Return Detail',
  '补发详情': 'Reshipment Detail',
  '退货数量': 'Return Quantity',
  '退货收货数量': 'Return Receiving Quantity',
  '补发数量': 'Reshipment Quantity',
  '补发收货数量': 'Reshipment Receiving Quantity',
  '退货人': 'Returner',
  '补发人': 'Reshipper',
  '退货中': 'Returning',
  '收货中': 'Receiving',
  '已收货': 'Received',
  '补发中': 'Reshipping',
  '已补发': 'Reshipped',
  '已完成': 'Completed',
  '售后类型': 'After-sales Type',
  '其他': 'Other',
  '其他原因': 'Other reason',
}

const StockChangePage = {
  '类型': 'Type',
  '关联订单号': 'Associated Order Number',
  '商品数量': 'Product Quantity',
  '关联生产单信息': 'Associated Production Order Information',
  '关联销售单信息': 'Associated Sales Order Information',
  '销售数量': 'Sales Quantity',
  '关联采购单': 'Associated Purchase Order',
  '客户': 'Customer',
  '客户拥有人': 'Customer Owner',
  '关联采购单信息': 'Associated Purchase Order Information',
  '采购数量': 'Purchase Quantity',
  '供应商': 'Supplier',
}

const StockPage = {
  '库存详情': 'Detail',
}

const SaleOutWarehousePage = {
  '请选择关联销售单': 'Please select associated sales order',
}

const SaleOrderPage = {
  '确定接收': 'Confirm Receipt',
  '创建生产单': 'Create Production Order',
  '销售出库详情': 'Sales Outbound Detail',
  '采购地区': 'Procurement Region',
  '销售出库数量': 'Sales Outbound Quantity',
  '发货时间': 'Shipment Time',
  '请输入采购数量': 'Please enter purchase quantity',
  '采购数量必须大于0': 'Purchase quantity must be greater than 0',
  '请选择客户': 'Please select customer',
  '请选择采购地区': 'Please select procurement region',
  '请选择出货日期': 'Please select the shipment date',
  '采购方': 'Purchaser',
  '采购方备注': 'Purchaser Remark',
}

const PurchaseInWarehousePage = {
  '采购商品数量': 'Purchase Product Quantity',
  '入库商品数量': 'Inbound Product Quantity',
}

const PurchaseOrderPage = {
  '采购': 'Purchase',
  '发货日期': 'Shipment Date',
  '采购入库详情': 'Purchase Inbound Detail',
  '采购入库数量': 'Purchase Inbound Quantity',
  '请选择供应商': 'Please select supplier',
  '请输入采购数量': 'Please enter purchase quantity',
  '采购数量必须大于0': 'Purchase quantity must be greater than 0',
  '请选择发货日期': 'Please select the shipment date',
  '发货数量': 'Shipping Quantity',
  '出货备注': 'Shipping Remark',
  '入库备注': 'Inbound Remark',
  '销售方': 'Seller',
  '销售方备注': 'Seller Remark',
}

const AppUserPage = {
  '用户名称': 'User Name',
  '手机号': 'Mobile Number',
  '邮箱': 'Email',
  '用户账号': 'User Account',
  '车型': 'Vehicle Model',
  '绑定数': 'Binding Count',
}

const ProduceInWarehousePage = {
  '请选择关联生产单': 'Please select associated production order',
}

const ProduceOrderPage = {
  '生产入库详情': 'Production Inbound Detail',
  '生产数量': 'Production Quantity',
  '生产入库数量': 'Production Inbound Quantity',
  '请输入生产数量': 'Please enter production quantity',
  '生产数量必须大于0': 'Production quantity must be greater than 0',
  '请输入装箱码、激活码或者产品码': 'Please enter packing code, activation code or product code',
  '产品箱装数量': 'Product Box Quantity',
  '请先选择要打印的装箱码': 'Please select the packing codes to print first',
  '确定要打印#个装箱码': 'Confirm to print # packing codes',
  '请先选择要打印的产品码': 'Please select the product codes to print first',
  '确定要打印#个产品码': 'Confirm to print # product codes',
  '绑定状态': 'Binding Status',
  '已绑定': 'Bound',
  '待绑定': 'Pending Binding',
  '新增箱子': 'Add Box',
  '编辑箱子': 'Edit Box',
  '箱子数量': 'Box Quantity',
  '请输入箱子数量': 'Please enter box quantity',
  '箱子数量必须大于0': 'Box quantity must be greater than 0',
  '编码生成方式': 'Code Generation Method',
  '设备生成': 'Device Generated',
  '系统生成': 'System Generated',
}

const OnSaleProductPage = {
  '库存': 'Inventory',
  '请输入库存': 'Please enter inventory',
  '新增在售产品': 'Add On-Sale Product',
  '配置在售产品': 'Configure On-Sale Product',
  '旧单价': 'Old Price',
  '单价更新时间': 'Price Update Time',
}

const ProductPage = {
  '导入': 'Import',
  '模版下载': 'Template Download',
  '文件格式为.xlsx、.xls': 'File format must be .xlsx, .xls',
  '导入完毕，成功：#1，失败：#2': 'Import completed, successful: #1, failed: #2',
  '产品导入模板': 'Product Import Template',
  '请输入产品名称': 'Please enter product name',
  '请上传图片': 'Please upload image',
  '请输入产品单价': 'Please enter product price',
  '请输入规格编码': 'Please enter specification code',
  '规格编码不能少于2位': 'Specification code cannot be less than 2 digits',
  '规格编码只能包含数字、英文大小写': 'Specification code can only contain numbers and English letters (case sensitive)',
  '图片尺寸为800x800': 'Image dimensions is 800x800',
  '规格编码': 'Specification Code',
  '规格编码为数字+英文大小写的6位编码': 'Specification code must be a 6-digit code containing numbers and English letters (case sensitive)',
  '图片格式为.jpeg、.jpg、.png': 'Image format must be .jpeg, .jpg, .png',
  '图片必须小于1M': 'Image must be less than 1M',
  '图片尺寸必须为800x800': 'Image dimensions must be 800x800',
  '产品指导价': 'Suggested Retail Price',
  '国家': 'Country',
  '价格': 'Price',
  '请添加指导价': 'Please add suggested retail price',
  '请选择国家': 'Please select country',
  '国家重复': 'Duplicate country',
  '功能列表': 'Feature List',
  '设备锁': 'Device Lock',
}

const AgentPage = {
  '代理账号': 'Agent Account',
  '代理名称': 'Agent Name',
  '代理总数': 'Total Agents',
  '代理手机号': 'Agent Mobile Number',
  '代理邮箱': 'Agent Email',
  '地区': 'Region',
  '地址': 'Address',
  '请输入代理账号': 'Please enter agent account',
  '代理账号只能包含数字和英文字母': 'Agent account can only contain numbers and English letters',
  '请输入代理名称': 'Please enter agent name',
  '代理名称长度必须介于 2 和 20 之间': 'Agent name length must be between 2 and 20 characters',
  '请输入代理手机号': 'Please enter agent mobile number',
  '手机号只包含数字': 'Mobile number must contain only digits',
  '手机号无需加区号': 'No area code needed for mobile number',
  '请输入代理邮箱': 'Please enter agent email',
  '请选择地区': 'Please select region',
  '请输入地址': 'Please enter address',
  '下级代理': 'Sub-agent',
  '代理采购记录': 'Agent Purchase Record',
  '代理库存': 'Agent Inventory',
  '拥有者': 'Owner',
  '迁移': 'Migration',
  '迁移代理': 'Migration',
  '请选择拥有者': 'Please select owner',
  '采购时间': 'Purchase Time',
  '下载模版': 'Download Template',
  '下载成功': 'Download successful',
  '下载失败': 'Download failed',
  '代理导入模版': 'Agent Import Template',
  '导入成功': 'Import successful',
  '导入失败': 'Import failed',
}

const SupplierPage = {
  '供应商账号': 'Supplier Account',
  '供应商名称': 'Supplier Name',
  '请输入供应商名称': 'Please enter supplier name',
  '供应商联系方式': 'Supplier Contact Information',
  '请输入供应商联系方式': 'Please enter supplier contact information',
  '供应商地址': 'Supplier Address',
  '请输入供应商地址': 'Please enter supplier address',
  '查看供应商': 'Detail',
}

const StatisticsPage = {
  '用户': 'Users',
  '绑定信息': 'Binding Information',
  '库存数量': 'Inventory Quantity',
  '代理入库总数': 'Total Agent Warehouse Quantity',
  '产品未激活总数': 'Total Unactivated Products',
  '产品激活详情': 'Product Activation Details',
  '产品激活排行': 'Product Activation Ranking',
  '售后产品数': 'After-sales Products',
  '请输入名称搜索内容': 'Please enter name to search',
  '总代账号': 'Agent Account',
  '全店数据概况': 'Store Data Overview',
  '统计首页': 'Statistics Home',
  '首页': 'Home',
  '至': 'to',
  '表格': 'Table',
  '图标': 'Chart',
  '注册人数': 'Registered Users',
  '国家': 'Country',
  '请输入国家名称': 'Please enter country name',
  '总代理商名称': 'Agent Name',
  '总代理名称': 'Agent Name',
  '总代理商号': 'Agent Code',
  '总代理昵称': 'Agent Nickname',
  '代理门店数': 'Store Count',
  '员工数': 'Employee Count',
  '采购数': 'Purchase Count',
  '采购订单数': 'Order Count',
  '业务员': 'Staff',
  '起始时间': 'Start Time',
  '结束时间': 'End Time',
  '更新于': 'Updated at',
  '日': 'Day',
  '周': 'Week',
  '月': 'Month',
  '开始日期': 'Start Date',
  '结束日期': 'End Date',
  '数据首页': 'Data Homepage',
  '用户总注册人数': 'Total User Registrations',
  '产品销售总数': 'Total Product Sales',
  '产品激活总数': 'Total Product Activations',
  '代理总数': 'Total Agents',
  '用户注册人数': 'User Registrations',
  '产品销售数': 'Product Sales',
  '产品激活数': 'Product Activations',
  '入库数量': 'Stock Quantity',
  '未激活数量': 'Inactive Quantity',
  '产品编号': 'Product ID',
  '代理地区': 'Agent Region',
  '请输入搜索内容': 'Please enter search content',
  '销售单总数': 'Total Sales Orders',
  '订单编号': 'Order Number',
  '销售数量': 'Sales Quantity',
  '销售时间': 'Sales Time',
  '售后数量': 'After-sales Quantity',
  '销售单数': 'Sales Order Count',
  '产品售后数量': 'Product After-sales Quantity',
  '请输入搜索名称': 'Please enter search name',
  '销售订单数': 'Sales Orders',
  '销售员': 'Salesperson',
  '销售员账号': 'Salesperson Account',
  '产品编码': 'Product Code',
  '绑定时间': 'Binding Time',
  '激活信息': 'Activation Information',
  '用户绑定总数': 'Total User Bindings',
  '总代理商名称': 'Agent Name',
  '总代理账号': 'Agent Account',
  '用户绑定数': 'User Bindings',
  '注册时间': 'Registration Time',
  '请输入国家名称': 'Please enter country name',
  '详情功能暂未开放': 'Detail function not yet available',
  '剩余保修时间': 'Remaining Warranty Period',
  '天': 'days',
  '销售单产品总数': 'Total Products in Sales Order',
  '出库数量': 'Outbound Quantity',
  '代理入库数量': 'Agent Inbound Quantity',
  '未激活数量': 'Inactive Quantity',
  '产品售后数': 'Product After-sales Count',
  '销售单时间': 'Sales Order Time',
  '订单编号': 'Order Number',
  '起始时间': 'Start Time',
  '结束时间': 'End Time',
  '无图片': 'No Image',
  '代理数': 'Agents',
  '请选择': 'Please select',
  '产品销售': 'Product Sales',
  '产品激活': 'Product Activation',
  '销售方': 'Seller',
  '激活方': 'Activating Party',
  '归属方': 'Owning Party',
  '激活账号': 'Activate Account',
  '激活门店': 'Activation Store',
  '剩余保修时间': 'Remaining Warranty Time',
  '产品激活时间': 'Product Activation Time',
  '用户绑定时间': 'User Binding Time',
  '绑定数量': 'Binding Count',
  '国家地区': 'Country/Region',
  '注册时间': 'Registration Time',
  '各国注册人数对比': 'Comparison of Registered Users by Country',
  '暂无绑定信息': 'No Binding Information',
  '账号名称': 'Account Name',
  '平台数据概况': 'Platform Data Overview',
  '统计时间': 'Statistics Time',
  '今日': 'Today',
  '地区总代总数': 'Total Regional Agents',
  '销售单总数': 'Total Sales Orders',
  '采购单总数': 'Total Purchase Orders',
  '统计': 'Statistics',
  '代理数据概况': 'Agent Data Overview',
  '用户绑定总数': 'Total User Bindings',
  '代理门店总数': 'Total Agent Stores',
  '代理门店数': 'Agent Store Count',
  '操作': 'Action',
  '详情': 'Detail',
  '请输入代理名称': 'Please enter agent name',
  '代理名称': 'Agent Name',
  '代理总数': 'Total Agents',
  '账号': 'Account',
  '代理地区': 'Agent Region',
  '发展员名称': 'Developer Name',
  '发展员账号': 'Developer Account',
  '请输入搜索内容': 'Please enter search content',
  '产品售后总数': 'Total After-Sales',
  '激活数量': 'Activation Count',
  '用户绑定': 'User Binding',
  '产品售后': 'After-Sales',
  '代理门店': 'Agent Store',
  '产品激活排名详情': 'Product Activation Ranking Details',
  '商品排名分析': 'Product Ranking Analysis',
  '排名': 'Rank',
  '售后数量': 'After-Sales Count',
  '用户绑定数': 'User Bindings',
  '采购产品数': 'Purchase Quantity',
  '产品入库数': 'Inbound Quantity',
  '产品出库数': 'Outbound Quantity',
  '库存总数': 'Total Inventory',
  '采购工厂': 'Purchase Factory',
  '采购工厂账号': 'Purchase Factory Account',
  '采购单时间': 'Purchase Order Time',
  '订单总数': 'Total Orders',
  '产品采购总数': 'Total Purchase Quantity',
  '产品入库总数': 'Total Inbound Quantity',
  '产品出库总数': 'Total Outbound Quantity',
  '激活总数': 'Total Activations',
  '未激活总数': 'Total Inactive',
  '售后总数': 'Total After-sales',
  '请输入产品名称': 'Please enter product name',
  '代理门店': 'Agent Store',
  '代理账号': 'Agent Account',
  '手机号': 'Mobile Number',
  '邮箱': 'Email',
  '业务员名称': 'Salesperson Name',
  '业务员账号': 'Salesperson Account',
  '售后数': 'After-sales Count',
  '售后信息': 'After-sales Info',
  '售后门店': 'After-sales Store',
  '售后账号': 'After-sales Account',
  '原产品编码': 'Original Product Code',
  '更换产品编码': 'Replaced Product Code',
  '绑定用户': 'Bound User',
  '用户账号': 'User Account',
  '产品激活时间': 'Product Activation Time',
  '用户绑定时间': 'User Binding Time',
  '售后时间': 'After-sales Time',
  '代理名称': 'Agent Name',
  '用户名': 'Username',
  '昵称': 'Nickname',
  '保修天数': 'Warranty Days',
  '激活时间': 'Activation Time',
  '绑定时间': 'Binding Time',
  '创建时间': 'Creation Time',
  '激活数': 'Activation Count',
  '用户绑定数': 'User Binding Count',
  '激活门店': 'Activation Store',
  '激活账号': 'Activation Account',
  '激活昵称': 'Activation Nickname',
  '绑定昵称': 'Binding Nickname',
  '绑定账号': 'Binding Account',
  '销售详情': 'Sales Details',
  '请输入代理门店名称': 'Please enter agent store name',
  '销售方名称': 'Seller Name',
  '销售方账号': 'Seller Account',
}

const InsiteMessagePage = {
  '标题': 'Title',
  '内容': 'Content',
  '已读': 'Read',
  '未读': 'Unread',
  '全部已读': 'Mark All as Read',
  '确定全部设置为已读': 'Confirm mark all as read',
  '发送时间': 'Sent Time',
  '查看消息': 'View Message',
  '您有新的销售单': 'You have a new sales order',
  '订单号：{no}\n采购方：{purchaseTenantName}\n产品名称：{productName}\n件数：{caseQuantity}\n个数：{quantity}\n请尽快接单！': 'Order No: {no}\nPurchaser: {purchaseTenantName}\nProduct Name: {productName}\nCases: {caseQuantity}\nQuantity: {quantity}\nPlease accept the order as soon as possible!',
  '订单号：{no}\n采购方：{purchaseTenantName}\n产品名称：{productName}\n数量：{quantity}\n请尽快接单！': 'Order No: {no}\nPurchaser: {purchaseTenantName}\nProduct Name: {productName}\nQuantity: {quantity}\nPlease accept the order as soon as possible!',
  '订单备注更新': 'Order Remark Updated',
  '订单号：{no}\n备注：{remark}': 'Order No: {no}\nRemark: {remark}',
  '销售单作废': 'Sales Order Voided',
  '订单号：{no}\n采购方：{purchaseTenantName}\n作废时间：{time}': 'Order No: {no}\nPurchaser: {purchaseTenantName}\nVoid Time: {time}',
  '完成销售单': 'Sales Order Completed',
  '订单号：{no}\n采购方：{purchaseTenantName}\n完成时间：{time}': 'Order No: {no}\nPurchaser: {purchaseTenantName}\nCompletion Time: {time}',
  '采购单接单': 'Purchase Order Accepted',
  '订单号：{no}\n销售方：{saleTenantName}\n接单时间：{time}': 'Order No: {no}\nSeller: {saleTenantName}\nAcceptance Time: {time}',
  '采购单作废': 'Purchase Order Voided',
  '订单号：{no}\n销售方：{saleTenantName}\n作废时间：{time}': 'Order No: {no}\nSeller: {saleTenantName}\nVoid Time: {time}',
  '生产入库': 'Production Inbound',
  '完成生产入库': 'Production Inbound Completed',
  '采购单发货': 'Purchase Order Shipped',
  '订单号：{no}\n销售方：{saleTenantName}\n件数：{caseQuantity}\n个数：{quantity}\n发货时间：{time}': 'Order No: {no}\nSeller: {saleTenantName}\nCases: {caseQuantity}\nQuantity: {quantity}\nShipment Time: {time}',
  '订单号：{no}\n销售方：{saleTenantName}\n个数：{quantity}\n发货时间：{time}': 'Order No: {no}\nSeller: {saleTenantName}\nQuantity: {quantity}\nShipment Time: {time}',
  '销售出库': 'Sales Outbound',
  '订单号：{no}\n件数：{caseQuantity}\n个数：{quantity}\n出库时间：{time}': 'Order No: {no}\nCases: {caseQuantity}\nQuantity: {quantity}\nOutbound Time: {time}',
  '订单号：{no}\n个数：{quantity}\n出库时间：{time}': 'Order No: {no}\nQuantity: {quantity}\nOutbound Time: {time}',
  '采购入库': 'Purchase Inbound',
  '订单号：{no}\n件数：{caseQuantity}\n个数：{quantity}\n入库时间：{time}': 'Order No: {no}\nCases: {caseQuantity}\nQuantity: {quantity}\nInbound Time: {time}',
  '订单号：{no}\n个数：{quantity}\n入库时间：{time}': 'Order No: {no}\nQuantity: {quantity}\nInbound Time: {time}',
  '完成采购单': 'Purchase Order Completed',
  '产品激活': 'Product Activation',
  '产品名称：{productName}\n激活人员：{staffName}\n激活时间：{time}': 'Product Name: {productName}\nActivated By: {staffName}\nActivation Time: {time}',
  '库存预警': 'Inventory Alert',
  '产品名称：{productName}\n数量：{quantity}\n请尽快补货！': 'Product Name: {productName}\nQuantity: {quantity}\nPlease restock as soon as possible!',
  '产品售后': 'After-sales Service',
  '产品名称：{productName}\n旧编码：{oldProductCode}\n新编码：{newProductCode}\n售后时间：{time}\n售后人员：{staffName}': 'Product Name: {productName}\nOld Code: {oldProductCode}\nNew Code: {newProductCode}\nAfter-sales Time: {time}\nHandled By: {staffName}',
  '新的退货申请': 'New Return Request',
  '产品名称：{productName}\n申请方：{applicantName}\n个数：{quantity}\n申请方：{applierName}': 'Product Name: {productName}\nApplicant: {applicantName}\nQuantity: {quantity}\nSubmitted By: {applierName}',
  '退货收货': 'Return Received',
  '产品名称：{productName}\n审批方：{approverName}\n个数：{quantity}\n收货时间：{time}': 'Product Name: {productName}\nApprover: {approverName}\nQuantity: {quantity}\nReceipt Time: {time}',
  '退货发货': 'Return Shipment',
  '产品名称：{productName}\n审批方：{approverName}\n个数：{quantity}\n发货时间：{time}': 'Product Name: {productName}\nApprover: {approverName}\nQuantity: {quantity}\nShipment Time: {time}',
  '完成退货': 'Return Completed',
  '产品名称：{productName}\n申请方：{applicantName}\n个数：{quantity}\n完成时间：{time}': 'Product Name: {productName}\nApplicant: {applicantName}\nQuantity: {quantity}\nCompletion Time: {time}',
}

const AgentPurchasePage = {
  '采购方': 'Purchaser',
  '代购人': 'Purchasing Agent',
  '代理': 'Agent',
  '请选择代理': 'Please select agent',
}

const CampaignPage = {
  '活动名称': 'Campaign Name',
  '开奖状态': 'Draw Status',
  '开奖进度': 'Draw Progress',
  '开奖编码': 'Draw Code',
  '领取状态': 'Claim Status',
  '已领取': 'Claimed',
  '未领取': 'Not Claimed',
  '未发布': 'Not Published',
  '参与中': 'Participated',
  '待开奖': 'Pending Draw',
  '开奖中': 'Drawing',
  '已结束': 'Ended',
  '查看地区': 'View Region',
  '信息收集': 'Information Collection',
  '活动条件': 'Campaign Conditions',
  '活动产品': 'Campagin Product',
  '选择产品': 'Select Product',
  '开奖人数': 'Max Number Of Participant',
  '参与范围': 'Eligibility',
  '产品来源仅限': 'Product Source Limited to',
  '起始时间': 'Start Time',
  '产品购买时间在': 'Product Purchase Time After',
  '后': '',
  '奖品': 'Prize',
  '奖品名称': 'Prize Name',
  '奖品图片': 'Prize Image',
  '图片尺寸为1:1': 'Image Size 1:1',
  '奖品价值': 'Prize Value',
  '奖品数量': 'Prize Quantity',
  '中奖规则': 'Winning Rules',
  '规则描述': 'Rule Description',
  '活动图': 'Campaign Image',
  '图片尺寸为690x420': 'Image Size 690x420',
  '内容': 'Content',
  '图片宽度为750像素': 'Image Width 750 pixels',
  '图片必须小于5M': 'Image Must Be Less Than 5M',
  '其他信息': 'Other Information',
  '领奖最后期限': 'Claim Deadline',
  '手机号码': 'Mobile Number',
  '开奖后': 'After draw',
  '天': 'Days',
  '请输入活动名称': 'Please Enter Campaign Name',
  '请上传图片': 'Please Upload Image',
  '请完善活动详情': 'Please Complete Campaign Details',
  '请选择活动产品': 'Please Select Product of Campaign',
  '请输入开奖人数': 'Please Enter Max Number Of Participant',
  '请选择查看地区': 'Please Select View Region',
  '请选择代理': 'Please Select Agent',
  '请选择起始时间': 'Please select start time',
  '请输入奖品名称': 'Please Enter Prize Name',
  '请上传奖品图片': 'Please Upload Prize Image',
  '请输入奖品数量': 'Please Enter Prize Quantity',
  '请选择信息收集方式': 'Please Select Information Collection Method',
  '请输入规则描述': 'Please Enter Rule Description',
  '请输入领奖最后期限': 'Please Enter Claim Deadline',
  '发布': 'Publish',
  '确定发布': 'Confirm Publish',
  '撤销': 'Revoke',
  '确定撤销': 'Confirm Revoke',
  '中奖信息': 'Winning Information',
  '中奖编码': 'Winning Code',
  '中奖用户': 'Winning User',
  '用户信息': 'User Information',
  '领奖状态': 'Prize Claim Status',
  '选择': 'Select',
  '最多10个产品': 'Up to 10 products',
  '时间类型': 'Time Type',
  '起止时间': 'Start and End Time',
  '请选择终止时间': 'Please select end time',
  '起始时间不能大于终止时间': 'Start time cannot be later than end time',
};

const BackEnd = {
  'No_Third_Party_Active_Code': 'Third-party activation code does not exist',
  'Error_Third_Party_Active_Code': 'Incorrect third-party activation code',
  'Not_Print_Third_Party_Active_Code': 'Third-party activation code not printed',
  'No_After_Sale_Code': 'After-sale code does not exist',
  'No_Goods': 'Product does not exist',
  'Not_Sale_Goods': 'Non-sales product',
  'No_Product_Code': 'Product code does not exist',
  'After_Sale_Code_Not_Belong_Product_Code': 'After-sale code does not belong to this product code',
  'No_New_Product_Code': 'New product code does not exist',
  'Error_Product_Code': 'Abnormal product code',
  'Not_Print_Product_Code': 'Product code not printed',
  'Not_Same_Product': 'Not the same product',
  'Active': 'Activated',
  'Out_Of_Stock': 'Out of stock',
  'No_App_User': 'User does not exist',
  'Invalid_Active_Code_Or_Invalid_Product_Code': 'Invalid activation code/product code',
  'No_Active_Code': 'Activation code does not exist',
  'Not_Active': 'Not activated',
  'Bind': 'Bound',
  'Account_Exist': 'Account duplicate',
  'Concat_Superior_Reset_Password': 'Contact superior to reset password',
  'No_User': 'User does not exist',
  'Old_Password_Error': 'Old password error',
  'No_Active_Code_Order': 'Third-party activation code order does not exist',
  'Invalid_Active_Code_Order_Status': 'Invalid third-party activation code order status',
  'Invalid_Quantity': 'Quantity error',
  'No_Agent': 'Agent does not exist',
  'Select_Agent': 'Please select agent',
  'No_Staff': 'Employee does not exist',
  'Enter_Agent_Name': 'Please enter agent name',
  'Enter_Agent_Phone': 'Please enter agent mobile number',
  'Select_Agent_Region': 'Please select agent region',
  'Enter_Agent_Address': 'Please enter agent address',
  'Select_Product': 'Please select product',
  'Enter_Goods_Quantity': 'Please enter product quantity',
  'Upload_File': 'Please upload file',
  'No_Insite_Message': 'Message does not exist',
  'No_Product': 'Product does not exist',
  'Enter_Price': 'Please enter price',
  'Invalid_Price': 'Invalid price',
  'Select_Produce_Order': 'Please select production order',
  'Select_Print_Type': 'Please select print type',
  'Invalid_Print_Type': 'Invalid print type',
  'No_Produce_Order': 'Production order does not exist',
  'Invalid_Produce_Order_Status': 'Invalid production order status',
  'Out_Of_Produce_Order_Goods_Quantity': 'Exceeded production quantity"',
  'Invalid_Box_Code': 'Invalid box code',
  'No_Box_Code': 'Box code does not exist',
  'Error_Box_Code': 'Abnormal box code',
  'Not_Print_Box_Code': 'Box code not printed',
  'Not_Same_Produce_Order': 'Not the same production order',
  'Produce_In_Warehouse': 'Produced in warehouse',
  'Select_Goods': 'Please select product',
  'Some_Goods_In_Warehouse': 'Some products are already in warehouse and cannot be voided',
  'Error_Active_Code': 'Abnormal activation code',
  'Not_Print_Active_Code': 'Activation code not printed',
  'Product_Associate_Box': 'Product already associated with packaging box',
  'Box_Not_Associate_Product': 'Packaging box not associated with product',
  'Box_Associate_Case': 'Packaging box already associated with packaging case',
  'Enter_Box_Quantity': 'Please enter box specification',
  'Scan_Active_Code': 'Please scan activation code',
  'Invalid_Active_Code': 'Invalid activation code',
  'Scan_Product_Code': 'Please scan product code',
  'Invalid_Product_Code': 'Invalid product code',
  'Scan_Box_Code': 'Please scan box code',
  'Success': 'Success',
  'Product_Name_Exist': 'Product name duplicate',
  'Sku_Exist': 'Sku duplicate',
  'Enter_Product_Name': 'Please enter product name',
  'Enter_Product_Sku': 'Please enter sku',
  'Not_Allow_Modify_Super_User': 'Not allowed to modify super administrator account',
  'No_Permission': 'No permission',
  'Import_Empty_User_Data': 'Imported user data is empty',
  'No_Purchase_Order': 'Purchase order does not exist',
  'Invalid_Purchase_Order_Status': 'Invalid purchase order status',
  'Out_Of_Purchase_Order_Goods_Quantity': 'Exceeded purchase quantity',
  'Not_Belong_Purchase_Order': 'Does not belong to this purchase order',
  'Select_Purchase_Order': 'Please select purchase order',
  'Select_PurchaseTenant': 'Please select purchaser',
  'Has_Goods_Not_Purchase_In_Warehouse': 'Seller has shipped but not in warehouse',
  'No_Sale_Order': 'Sales order does not exist',
  'Select_ShipmentTime': 'Please select shipment time',
  'No_Return_Goods': 'Return goods do not exist',
  'No_After_Sale': 'After-sale does not exist',
  'Return_Goods': 'Returned goods',
  'Invalid_Return_Goods_Record_Status': 'Invalid return record status',
  'Not_Belong_Return_Goods_Record': 'Does not belong to this return request',
  'Received': 'Received',
  'Out_Of_Return_Goods_Quantity': 'Exceeded return quantity',
  'No_Return_Goods_Record': 'Return record does not exist',
  'Invalid_Approver': 'Invalid reviewer',
  'Not_In_Warehouse': 'Not in warehouse',
  'Reship': 'Reshipped',
  'Select_Return_Goods_Record': 'Please select return record',
  'No_Allow_Operate_Super_Role': 'Not allowed to operate super administrator role',
  'No_Permission_Access_Role': 'No permission to access role',
  'No_Permission_Access_Dept': 'No permission to access department',
  'No_Allow_Add_Dept': 'Department disabled, addition not allowed',
  'Invalid_Sale_Order_Status': 'Invalid sales order status',
  'Some_Goods_Out_Warehouse': 'Some products are already out of warehouse and cannot be voided',
  'Out_Of_Sale_Order_Goods_Quantity': 'Exceeded sales quantity',
  'Select_Sale_Order': 'Please select sales order',
  'Not_Associate': 'Not associated',
  'Scan_Code': 'Please scan code',
  'Enter_Nick_Name': 'Please enter name',
  'Select_MenuIds': 'Please select menu',
  'No_Stock_Change': 'Inventory change does not exist',
  'Enter_Supplier_Name': 'Please enter supplier name',
  'Enter_Supplier_Phone': 'Please enter supplier mobile number',
  'Enter_Company_Name': 'Please enter company name',
  'Enter_Company_Phone': 'Please enter company mobile number',
  'Enter_Company_Email': 'Please enter company email',
  'Enter_Contact_Name': 'Please enter contact name',
  'Enter_Contact_Phone': 'Please enter contact mobile number',
  'Enter_Contact_Email': 'Please enter contact email',
  'Enter_Captcha': 'Please enter captcha',
  'Captcha_Expire': 'Captcha expired',
  'Error_Captcha': 'Captcha error',
  'Enter_Account/Password': 'Please enter account/password',
  'Password_Not_Between_Range': 'Password not within specified range',
  'User_Name_Not_Between_Range': 'Username not within specified range',
  'IP_Be_Banned': 'IP banned from access',
  'Account_Be_Deleted': 'Account deleted',
  'Account_Be_Freeze': 'Account frozen',
  'Enter_User/Password': 'Please enter account/password',
  'Account_Between_2_And_20': 'Account length between 2 and 20',
  'Password_Between_6_And_20': 'Password length between 6 and 20',
  'Error Account/Password': 'Incorrect account/password',
  'Enter_Mobile_Phone': 'Please enter mobile phone number',
  'Enter_Email': 'Please enter email',
  'Frequently_Get_Captcha_Try_5_Minutes': 'Frequently get captcha, try again after 5 minutes',
  'No_User/Password_Error': 'User does not exist/Password error',
  'Purchase_In_Warehouse': 'Purchased in warehouse',
  'Sale_Out_Warehouse': 'Sold out warehouse"',
  'Free': 'Free',
  'CustomCode': 'Third-party activation code',
  'Order_Out_Of_Limit（999）': 'Exceeded limit (999)',
  'Other': 'Other',
  'No_Campaign': 'Campaign does not exist',
  'Not_In_Participate': 'Outside participation period',
  'Has_Participant': 'There are participating users',
  'Has_One_Active': 'There are published campaigns',
  'Has_One_Participate': 'There are campaigns with existing participants',
  'Participated': 'Participated',
  'No_Valid_Bind_Product': 'No eligible product bound',
  'Invalid_Accept_No': 'Invalid claim code',
  'Accept_Prize': 'Prize claimed',
  'Scan_Accept_No': 'Please scan claim code',
  'Out_Of_Accept_Deadline': 'Exceeded claim deadline',
  'Enter_Title': 'Please enter campaign name',
  'Upload_Banner': 'Please upload banner',
  'Enter_Content': 'Please complete content',
  'Enter_Max_Participant_Quantity': 'Please enter maximum number of participants"',
  'Select_Limit_Date': 'Please select restriction time',
  'Improve_Prize': 'Please complete prize',
  'Select_Contact_Method': 'Please select contact method',
  'Enter_Rule_Desc': 'Please enter rule description',
  'Enter_Accept_Deadline': 'Please enter claim deadline',
  'Enter_Phone': 'Please enter phone',
  'Out_Of_Max_Participant_Quantity': 'Exceeded maximum number of participants',
  'Not_Bind': 'Not bound',
  'Select_Purchase_Order': 'Please select purchase order',
  'Empty_Product_Code': 'Product code cannot be empty',
  'Product_Not_Found': 'Product not found',
  'Empty_Box_Code': 'Box code is empty',
  'Print_Failed': 'Print failed, please check printer status',
  'Empty_Product_Code': 'Product code is empty',
  'Product_Code_Not_Exist': 'Product code does not exist',
  'Box_Code_Not_Exist': 'Box code does not exist',
  'System_Clock_Backwards': 'System clock moved backwards, ID generation rejected',
  'Empty_User_Id': 'User ID cannot be empty',
  'Empty_Tenant_Id': 'tenantId cannot be empty',
  'Empty_Product_Id': 'productId cannot be empty',
  'Please_Enter_Product_Id': 'Please enter productId',
  'Invalid_Product_Code_Empty_Part': 'Invalid product code: empty segment',
  'Invalid_Product_Code_Format': 'Invalid product code format',
  'Not_Same_Product': 'Not the same product model',
  'Empty_Code': 'Verification code is empty',
  'Product_Not_Exist': 'Product does not exist',
  'Product_Unlocked': 'Product already unlocked',
  'Product_Not_Activated': 'Product not activated',
  'Inconsistent_Product_Code': 'Product code mismatch',
  'No_Empty_Type': 'Type cannot be empty',
  'No_Empty_Reason': 'Reason cannot be empty',
  'Invalid_Product_Code_Or_Invalid_Active_Code': 'Invalid product code or activation code',
  '请选择要导入的文件': 'Please select a file to import',
  '请使用正确的导入模板': 'Please use the correct import template',
  '文件名不能为空': 'File name cannot be empty',
  '文件格式错误': 'File format error',
  '请上传Excel文件': 'Please upload an Excel file',
  'Excel格式错误': 'Excel format error',
  'Excel内容为空': 'Excel content is empty',
  'Row{}：Enter_Agent_Account': 'Row {}: Please enter agent account',
  'Row{}：UserName_Only_Contain_Number_And_English': 'Row {}: Account can only contain numbers and English letters',
  'Row{}：UserName_Exist': 'Row {}: Account already exists',
  'Row{}：Enter_Agent_Name': 'Row {}: Please enter agent name',
  'Row{}：Enter_Phone_Number': 'Row {}: Please enter phone number',
  'Row{}：Invalid_Phone_Number': 'Row {}: Invalid phone number',
  'Row{}：Select_Region': 'Row {}: Please select region',
  'Row{}：Invalid_Region': 'Row {}: Invalid region',
  'Row{}：Enter_Address': 'Row {}: Please enter address',
  '生成Excel失败': 'Failed to generate Excel',
  '请输入国家名称': 'Please enter country name',
  '订单不存在': 'Order does not exist',
  '箱规必须大于0': 'Case pack must be greater than 0',
  '箱子已绑定产品，不能删除': 'Box is already bound to product and cannot be deleted',
  '箱子不存在': 'Box does not exist',
  '该箱已绑定产品': 'This box is already bound to a product',
  '订单ID不能为空': 'Order ID cannot be empty',
  'Enter_Agent_Account': 'Please enter agent account',
  'Enter_Staff_Account': 'Please enter staff account',
  'UserName_Only_Contain_Number_And_English': 'Account can only contain numbers and English letters',
  'UserName_Exist': 'Account already exists',
  'Enter_Staff_Name': 'Please enter staff name',
  'Enter_Remark': 'Please enter remark',
}

export default {
  ...Common,
  ...Layout,
  ...Menu,
  ...Region,
  ...ModifyPasswordPage,
  ...LoginPage,
  ...TenantPage,
  ...RolePage,
  ...StaffPage,
  ...PrintRecordPage,
  ...ThirdPartyActivationCodeOrderPage,
  ...ThirdPartyActivationCodeRecordPage,
  ...TraceCodePage,
  ...ReturnPage,
  ...StockChangePage,
  ...StockPage,
  ...SaleOutWarehousePage,
  ...SaleOrderPage,
  ...PurchaseInWarehousePage,
  ...PurchaseOrderPage,
  ...AppUserPage,
  ...ProduceInWarehousePage,
  ...ProduceOrderPage,
  ...OnSaleProductPage,
  ...ProductPage,
  ...AgentPage,
  ...SupplierPage,
  ...StatisticsPage,
  ...InsiteMessagePage,
  ...AgentPurchasePage,
  ...CampaignPage,
  ...BackEnd,
}